import NotesTab from "../../../../patient/details/notes/NotesTab";

export default function NotesDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <NotesTab inWorkQ={inWorkQ} />
    </div>
}
